__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@erp-platform/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@atlas/api-client", "0.0.0", () => (() => (__webpack_require__(2568))), 1);
			register("@atlas/shared-auth", "0.0.0", () => (() => (__webpack_require__(4424))), 1);
			register("@atlas/shared-state", "0.0.0", () => (() => (__webpack_require__(8182))), 1);
			register("@atlas/shared-types", "0.0.0", () => (() => (__webpack_require__(5801))), 1);
			register("@atlas/shared-ui", "0.0.0", () => (() => (__webpack_require__(7968))), 1);
			register("@mantine/core", "8.3.18", () => (() => (__webpack_require__(2308))), 1);
			register("@mantine/dates", "8.3.18", () => (() => (__webpack_require__(4808))), 1);
			register("@mantine/hooks", "8.3.18", () => (() => (__webpack_require__(2123))), 1);
			register("@mantine/modals", "8.3.18", () => (() => (__webpack_require__(7043))), 1);
			register("@mantine/notifications", "8.3.18", () => (() => (__webpack_require__(620))), 1);
			register("@tanstack/react-query", "5.90.21", () => (() => (__webpack_require__(4553))), 1);
			register("react-dom", "19.2.4", () => (() => (__webpack_require__(3144))), 1);
			register("react-router-dom", "6.30.3", () => (() => (__webpack_require__(8955))), 1);
			register("react", "19.2.4", () => (() => (__webpack_require__(4041))), 1);
			register("zustand/middleware/immer", "5.0.11", () => (() => (__webpack_require__(233))), 1);
			register("zustand", "5.0.11", () => (() => (__webpack_require__(1087))), 1);
			initExternal(5480);
			initExternal(8719);
			initExternal(987);
			initExternal(2240);
			initExternal(6603);
			initExternal(2620);
			initExternal(2157);
			initExternal(1073);
			initExternal(7468);
			initExternal(3509);
			initExternal(6902);
			initExternal(1107);
			initExternal(9061);
			initExternal(8993);
			initExternal(8509);
			initExternal(9066);
			initExternal(7318);
			initExternal(8880);
			initExternal(8560);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};